import * as React from "react";
import Svg, { G, Path, Defs, ClipPath, Rect } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#clip0_997_4789)">
      <Path
        opacity={0.2}
        d="M10 4.375C3.75 4.375 1.25 10 1.25 10C1.25 10 3.75 15.625 10 15.625C16.25 15.625 18.75 10 18.75 10C18.75 10 16.25 4.375 10 4.375ZM10 13.125C9.38193 13.125 8.77775 12.9417 8.26384 12.5983C7.74994 12.255 7.3494 11.7669 7.11288 11.1959C6.87635 10.6249 6.81447 9.99653 6.93505 9.39034C7.05562 8.78415 7.35325 8.22733 7.79029 7.79029C8.22733 7.35325 8.78415 7.05562 9.39034 6.93505C9.99653 6.81447 10.6249 6.87635 11.1959 7.11288C11.7669 7.3494 12.255 7.74994 12.5983 8.26384C12.9417 8.77775 13.125 9.38193 13.125 10C13.125 10.8288 12.7958 11.6237 12.2097 12.2097C11.6237 12.7958 10.8288 13.125 10 13.125Z"
        fill="#0E8741"
      />
      <Path
        d="M3.75 3.125L16.25 16.875"
        stroke="#0E8741"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12.1024 12.3125C11.4891 12.8701 10.6794 13.1612 9.85146 13.1218C9.02351 13.0824 8.24514 12.7157 7.68756 12.1023C7.12998 11.489 6.83888 10.6793 6.87829 9.8514C6.91771 9.02345 7.2844 8.24508 7.89772 7.6875"
        stroke="#0E8741"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M10.5884 6.93042C11.2528 7.05765 11.8579 7.39702 12.3129 7.89755C12.768 8.39808 13.0483 9.03274 13.1118 9.7062"
        stroke="#0E8741"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16.2976 13.2109C18.0007 11.6859 18.7499 10 18.7499 10C18.7499 10 16.2499 4.37501 9.9999 4.37501C9.45867 4.37427 8.91829 4.41817 8.38428 4.50626"
        stroke="#0E8741"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M5.78125 5.35938C2.59609 6.97187 1.25 10 1.25 10C1.25 10 3.75 15.625 10 15.625C11.4645 15.6365 12.9106 15.2991 14.2188 14.6406"
        stroke="#0E8741"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_997_4789">
        <Rect width={20} height={20} fill="white" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
